module.exports = __webpack_public_path__ + "img/11_50.6656f24a.png";